import React, { Component } from 'react';
import logo from '../../images/logo-chrome-color.svg';
import log from '../utils/log.js'

class GetChromeExtension extends Component {

  constructor() {
    super()
    this.state = {
      isInstalled: null
    }
  }

  componentDidMount() {
    setTimeout(() => {
      this.setState({
        isInstalled: this.checkIfInstalled()
      })
    }, 2000)
  }

  checkIfInstalled() {
    return document.getElementById('waat-extension-is-installed') ? true : false
  }

  onClick(e) {
    e.preventDefault()
    window.chrome.webstore.install('https://chrome.google.com/webstore/detail/ecipajkikehicjnpnnjgngcmnfcmnpaj', (e) => {
      log(e);
    }, (e) => {
      console.error(e)
      window.open('https://chrome.google.com/webstore/detail/waattv/ecipajkikehicjnpnnjgngcmnfcmnpaj')
    })
  }

  render() {

    let { isInstalled } = this.state

    // https://developer.chrome.com/webstore/inline_installation
    // TODO check if extension already exists
    if (isInstalled === null || isInstalled) {
      return null
    }

    let style = { 'backgroundImage':`url(${logo})` }
    // const url = 'https://chrome.google.com/webstore/detail/waattv/ecipajkikehicjnpnnjgngcmnfcmnpaj'
    return (
      <a href="" onClick={this.onClick.bind(this)} className={"get-chrome-extension btn btn--"+this.props.color} >
        <span style={style} ></span>
        Add chrome extension
      </a>
    )
  }
}

GetChromeExtension.defaultProps = {
  color: 'blue'
}

export default GetChromeExtension



/** WEBPACK FOOTER **
 ** ./src/scripts/components/GetChromeExtension.js
 **/